<template>
  <router-view></router-view>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'app',
  computed: {
    ...mapGetters([
      'lang'
    ])
  },
  created () {
    if (localStorage.getItem('lang')) {
      this.$i18n.locale = localStorage.getItem('lang')
    } else {
      this.$i18n.locale = this.lang
    }
  }
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';
</style>
